var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLindsayAdamsMediaAndDesignArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "95.5px",
    height: "95.5px",
    viewBox: "0 0 95.5 95.5",
    style: {
      enableBackground: "new 0 0 95.5 95.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F2022;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.1,28.1v40.3c0,0.6-0.7,0.8-1.1,0.4L26.8,28.6c-0.4-0.4-0.1-1.1,0.4-1.1h40.3 C67.8,27.5,68.1,27.8,68.1,28.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLindsayAdamsMediaAndDesignArrow);
export default __webpack_public_path__ + "static/media/lindsay-adams-media-and-design-arrow.680cb05cd783d38c18a41eda527f8c21.svg";
export { ForwardRef as ReactComponent };